module.exports = __webpack_public_path__ + "static/media/2playerRoomsPlayed_5000_10000.9b1ece8f.png";